import { Popover } from "antd";
import React from "react";

const SapDocumentsData = ({ item, getSvgIcon, key, downloadFile }) => {

  return (
    <div
      key={key}
      onClick={() => downloadFile(item.id, item.name)}
      style={{ cursor: "pointer" }}
    >
      {getSvgIcon(item.type)}
      <div className="mt-1">
        <Popover content={item.name} trigger="hover">
          <span>{item.name.slice(0, 6)}...</span>
        </Popover>
      </div>
    </div>
  );
};

export default SapDocumentsData;
